import { useMemo } from 'react';
import { clsx } from 'clsx';
import { Grid } from '../../../../alignment/grid';
import { Typography } from '../../../../typography';
import styles from './month-grid.module.scss';

interface MonthGridProps {
  focusedMonth: number;
  onSelectMonth: (month: number) => void;
}

export function MonthGrid({ focusedMonth, onSelectMonth }: MonthGridProps) {
  const monthOptions = useMemo(
    () =>
      Array.from({ length: 12 }, (_, i) => ({
        label: new Date(2021, i, 1).toLocaleString('en-US', { month: 'short' }),
        value: i + 1,
      })),
    [],
  );

  return (
    <Grid autoColumns={3} className={styles.monthGrid} rowGap={2}>
      {monthOptions.map((month) => {
        const isActive = focusedMonth === month.value;

        return (
          <button
            className={clsx(styles.option, isActive ? styles.isActive : undefined)}
            key={month.value}
            onClick={() => {
              onSelectMonth(month.value);
            }}
            type="button"
          >
            <Typography lineHeight="0.875rem" size="0.875rem" tone={isActive ? 'background' : 'md'}>
              {month.label}
            </Typography>
          </button>
        );
      })}
    </Grid>
  );
}
